export function PageHeader({ overline, title, description, children, icon }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div className="flex items-start gap-4">
        {icon}
        <div>
          {overline && <p className="overline text-muted-foreground mb-2">{overline}</p>}
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-none">{title}</h1>
          {description && <p className="text-muted-foreground mt-3 max-w-2xl leading-relaxed">{description}</p>}
        </div>
      </div>
      {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, accent, testid }) {
  return (
    <div className="bg-card border border-border rounded-2xl p-5 hover:border-[hsl(var(--border-hover))] hover:-translate-y-0.5 transition-all duration-300" data-testid={testid}>
      <p className="overline text-muted-foreground">{label}</p>
      <p className="font-display text-3xl font-bold mt-2 tracking-tight" style={accent ? { color: accent } : {}}>{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}

export function EmptyState({ icon, title, hint, action }) {
  return (
    <div className="border border-dashed border-border rounded-lg p-12 text-center">
      <div className="mx-auto mb-4 h-11 w-11 grid place-items-center rounded-md bg-secondary text-muted-foreground">{icon}</div>
      <p className="font-display font-semibold">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1 max-w-sm mx-auto">{hint}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Pill({ children, tone = "default", testid }) {
  const tones = {
    default: "bg-secondary text-secondary-foreground border-border",
    danger: "bg-danger/12 text-danger border-danger/20",
    warning: "bg-warning/15 text-warning border-warning/25",
    success: "bg-success/12 text-success border-success/20",
    accent: "bg-accent/12 text-accent border-accent/20",
  };
  return (
    <span data-testid={testid} className={`inline-flex items-center text-[0.7rem] font-medium px-2 py-0.5 rounded border ${tones[tone] || tones.default}`}>
      {children}
    </span>
  );
}

export function relTime(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "nyss";
  if (diff < 3600) return `${Math.floor(diff / 60)} min sedan`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} tim sedan`;
  return new Date(iso).toLocaleDateString("sv-SE", { day: "numeric", month: "short" });
}
